
import apiHelpers from './apiHelpers.js';
import { mapCrudStoreGen } from '@/helpers/utils/storeHelpers.js';
let defaultForm = {
  email: '',
  firstName: '',
  lastName: '',
  brandId: '',
  roleType: 'brand-user',
  redirectToUrl: '',
  sendEmailImmediately: true
};

let defaultFilters = {
  search: '',
  brandId: '',
  roleType: '',
  userSignedUp: null,
  emailInviteSent: null
};

let genedStore = mapCrudStoreGen(defaultForm, defaultFilters, apiHelpers);

export default {
  namespaced: true,

  state: () => ({
    ...genedStore.state
  }),

  mutations: {
    ...genedStore.mutations
  },

  getters: {
    ...genedStore.getters
  },

  actions: {
    ...genedStore.actions
  },
};
